import { render } from "./FileUploadComponent.vue?vue&type=template&id=16f12aed"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QUploader});
